<!--
Displays text that collapses by default if over a given character limit.
Chevrons are shown at the bottom to expand/collapse text.
Usage: <ExpandableText content="some content" limit=20 />

If a limit isn't given the text won't be truncated and no chevron will be shown
@author cm359n
-->
<template>
  <div class="textcontainer">
  <table class="texttable">
      <tr :class="'textcontent-' + (expanded ? 'expand' : 'collapse')">
        <td v-if="!styleoverride" class="textcontent" v-html="dispContent()"></td>
        <td v-else :style="styleoverride" class="textcontent" v-html="content"></td>
      </tr>
      <tr v-if="textIsTooLong()">
        <td class="expandChev">
            <img @click="toggleChev()" v-if="expanded" src="@/assets/br_up.svg" title="collapse" alt="collapse">
            <img @click="toggleChev()" v-else src="@/assets/br_down.svg" title="expand" alt="expand">
        </td>
      </tr>
  </table>
  </div>
</template>

<script>
import StringUtil from '@/mixins/StringUtil.js'

export default {
  name: 'ExpandText',
  props: ['content', 'limit', 'allowExtra', 'styleoverride'],
  data () {
    return {
      expanded: false
    }
  },
  mixins: [StringUtil],
  methods: {
    toggleChev () {
      this.expanded = !this.expanded
    },
    textIsTooLong () {
      // text is not too long if the limit is not given or is not a number :-P
      let ret = false
      if (typeof this.limit === 'number' && typeof this.content === 'string') {
        let characterLimit = this.limit
        if (typeof this.allowExtra === 'number') {
          characterLimit += this.allowExtra
        }
        if (this.content.length > characterLimit) {
          ret = true
        }
      }
      return ret
    },
    dispContent () {
      let ret = this.content
      if (!this.expanded && this.textIsTooLong()) {
        ret = ret.substr(0, this.limit) + '...'
      }
      return ret
    }
  }
}
</script>

<style scoped>
content {
  font-size: 16px;
}
td.textcontent {
  font-size:16px;
}
td.expandChev {
  text-align: center;
}
</style>
